import { render, staticRenderFns } from "./Barcode.vue?vue&type=template&id=6876c37a&"
import script from "./Barcode.vue?vue&type=script&lang=ts&"
export * from "./Barcode.vue?vue&type=script&lang=ts&"
import style0 from "./Barcode.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports